import {
  IC_EVT_AUDIO_PLAYBACK_STARTED, IC_EVT_STREAMED_EPISODE_START, IC_EVT_STREAMED_EPISODE, IC_EVT_STREAMED_GENRE_START, IC_EVT_STREAMED_GENRE
} from '@/config/events-intercom/events';
import {
  IC_META_EPISODE_ID,
  IC_META_EPISODE_NUMBER,
  IC_META_EPISODE_SEASON_NUMBER,
  IC_META_GENRES,
  IC_META_GENRE_ID,
  IC_META_GENRE_PARENT_ID,
  IC_META_GENRE_PARENT_TITLE,
  IC_META_GENRE_TITLE,
  IC_META_PERCENTAGE_PROGRESS,
  IC_META_SHOW_ID,
  IC_META_SHOW_TITLE,
  IC_META_TOTAL_LISTENING_TIME
} from '@/config/events-intercom/metadata';

export const ICstreamedEpisodeStart = ({
  episodeId,
  episodeNumber,
  seasonNumber,
  showId,
  showTitle,
  genres
}) => ({
  eventName: IC_EVT_STREAMED_EPISODE_START,
  metadata: {
    [IC_META_EPISODE_ID]: episodeId,
    [IC_META_EPISODE_NUMBER]: episodeNumber,
    [IC_META_EPISODE_SEASON_NUMBER]: seasonNumber,
    [IC_META_SHOW_ID]: showId,
    [IC_META_SHOW_TITLE]: showTitle,
    [IC_META_GENRES]: genres
  }
});

export const ICstreamedEpisode = ({
  episodeId,
  episodeNumber,
  seasonNumber,
  showId,
  showTitle,
  genres,
  percentageProgress,
  totalListeningTimeSeconds
}) => ({
  eventName: IC_EVT_STREAMED_EPISODE,
  metadata: {
    [IC_META_EPISODE_ID]: episodeId,
    [IC_META_EPISODE_NUMBER]: episodeNumber,
    [IC_META_EPISODE_SEASON_NUMBER]: seasonNumber,
    [IC_META_SHOW_ID]: showId,
    [IC_META_SHOW_TITLE]: showTitle,
    [IC_META_GENRES]: genres,
    [IC_META_PERCENTAGE_PROGRESS]: percentageProgress,
    [IC_META_TOTAL_LISTENING_TIME]: totalListeningTimeSeconds
  }
});

export const ICstreamedGenreStart = ({
  genreId,
  genreTitle,
  parentGenreId,
  parentGenreTitle
}) => ({
  eventName: IC_EVT_STREAMED_GENRE_START,
  metadata: {
    [IC_META_GENRE_ID]: genreId,
    [IC_META_GENRE_TITLE]: genreTitle,
    [IC_META_GENRE_PARENT_ID]: parentGenreId,
    [IC_META_GENRE_PARENT_TITLE]: parentGenreTitle
  }
});

export const ICstreamedGenre = ({
  genreId,
  genreTitle,
  parentGenreId,
  parentGenreTitle,
  totalListeningTimeSeconds
}) => ({
  eventName: IC_EVT_STREAMED_GENRE,
  metadata: {
    [IC_META_GENRE_ID]: genreId,
    [IC_META_GENRE_TITLE]: genreTitle,
    [IC_META_GENRE_PARENT_ID]: parentGenreId,
    [IC_META_GENRE_PARENT_TITLE]: parentGenreTitle,
    [IC_META_TOTAL_LISTENING_TIME]: totalListeningTimeSeconds
  }
});

export const ICaudioPlaybackStarted = () => ({ eventName: IC_EVT_AUDIO_PLAYBACK_STARTED });